import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";

const title = process.env.REACT_APP_TAB_TITLE;


// Set the title of the document
document.title = title;

if (process.env.REACT_APP_CLIENT === "ase") {
  document.documentElement.setAttribute("data-theme", "ase");
}

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);
